import React from 'react';
import { Text } from "../../Atoms";
import { IconTitleMolecule } from '../../Molecules';
import { TemplateRetryButton } from './../../Templates/index';
import PropTypes from 'prop-types';

function TemplatePaiementEchec({ mail, pathToPaiement }) {
    return (
      <div className="template-scroll template-container cotisations mt-20 d-flex flex-column">
 
        <div className="content-large-max">
          <IconTitleMolecule
            text="Echec du paiement"
            className="title-page font-title mt-40"
            icon="alert-error"
            size='icon-x2'
          />
          <Text
            text="Nous sommes désolés, le paiement de votre cotisation a échoué, veuillez réessayer."
            type="h8"
            className="mt-20"
          />
          <ul>
            <li>
              <Text
                text="Vérifiez que vous avez les fonds nécessaires sur votre compte bancaire."
                type="h8"
                className="mt-15"
              />
            </li>
            <li>
              <Text
                text="Vérifiez les informations de votre carte bancaires."
                type="h8"
                className="mt-10"
              />
            </li>
            <li>
              <Text
                text="Vérifiez auprès de votre banque les modalités de paiement en ligne."
                type="h8"
                className="mt-10"
              />
            </li> 
          </ul>
          <Text
            text={"Si votre tentative a de nouveau échouée, n'hésitez pas à nous contacter par mail, à l'adresse suivante : " + (mail || "comptabilite@cgrm.com")}
            type="h8"
            className="mt-20"
          />
          
          <TemplateRetryButton pathToPaiement={pathToPaiement} />
        </div>
      </div>
    );
}

// Validation des props
TemplatePaiementEchec.propTypes = {
  mail: PropTypes.string,
  pathToPaiement: PropTypes.string,
};

export default TemplatePaiementEchec;
